import { omit } from 'lodash-es'
import type { NavItem } from '@base/@layouts/types'

export const useLayoutStore = defineStore('layout', () => {
  const router = useRouter()

  const layoutItems = computed(
    () => createRouteTree(router.getRoutes()),
  )

  const horizontalLayoutItems = computed(
    () => layoutItems.value.map(
      i => omit(i, 'heading'),
    ) as NavItem[],
  )

  const isLoading = ref(false)

  function showLoading() {
    isLoading.value = true
  }

  function hideLoading() {
    isLoading.value = false
  }

  return {
    layoutItems,
    horizontalLayoutItems,
    isLoading,
    showLoading,
    hideLoading,
  }
})

export const usePageLayoutStore = defineStore('pageLayout', {
  state: () => ({
    pageContentStyle: {},
    scrollTop: 0, // 添加滚动位置状态
    isAtTop: true, // 添加是否在顶部的状态
  }),
  actions: {
    setPageContentStyle(styles: Record<string, string | number | boolean>) {
      this.pageContentStyle = styles
    },
    // 更新滚动位置
    updateScrollTop(scrollTop: number) {
      this.scrollTop = scrollTop
      // 注意：这里不再直接更新 isAtTop，而是通过 setIsAtTop 方法
    },
    // 设置是否在顶部的状态
    setIsAtTop(isAtTop: boolean) {
      this.isAtTop = isAtTop
    }
  }
})
